import { c as _c } from "react/compiler-runtime";
import MinimalHeader from "@components/MinimalHeader";
import { DefaultValues } from "react-hook-form";
import ApplicationStepHeader from "../ApplicationStepHeader";
import ApplicationSteps from "../ApplicationSteps";
import DynamicForm, { FieldValues } from "../DynamicForm";
import { FormStepComponent } from "../FormSteps/FormSteps";
import SplitLayout from "../SplitLayout";
const FormScreen = t0 => {
  const $ = _c(29);
  const {
    onNext,
    onPrevious,
    currentStepNumber,
    hasZeroStep,
    numberOfSteps,
    value,
    step,
    steps
  } = t0;
  const stepNumber = hasZeroStep ? currentStepNumber : currentStepNumber + 1;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MinimalHeader showTopBar={false} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentStepNumber || $[2] !== onPrevious || $[3] !== step || $[4] !== steps || $[5] !== value) {
    t2 = <SplitLayout.Aside><ApplicationSteps onPrevious={onPrevious} steps={steps} state={currentStepNumber} step={step} value={value} /></SplitLayout.Aside>;
    $[1] = currentStepNumber;
    $[2] = onPrevious;
    $[3] = step;
    $[4] = steps;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== step.config || $[8] !== stepNumber || $[9] !== value) {
    t3 = <ApplicationStepHeader config={step.config} currentStepNumber={stepNumber} value={value} />;
    $[7] = step.config;
    $[8] = stepNumber;
    $[9] = value;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = value as DefaultValues<T>;
  let t5;
  if ($[11] !== onNext) {
    t5 = values => onNext(values);
    $[11] = onNext;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== currentStepNumber || $[14] !== onPrevious) {
    t6 = currentStepNumber > 0 ? () => onPrevious() : undefined;
    $[13] = currentStepNumber;
    $[14] = onPrevious;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== step.config || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <DynamicForm id="form" defaultValues={t4} onSubmit={t5} formDefinition={step.config} onPrevious={t6} />;
    $[16] = step.config;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== currentStepNumber || $[22] !== numberOfSteps || $[23] !== t3 || $[24] !== t7) {
    t8 = <SplitLayout.Body currentStepNumber={currentStepNumber} numberOfSteps={numberOfSteps} state={currentStepNumber}>{t3}{t7}</SplitLayout.Body>;
    $[21] = currentStepNumber;
    $[22] = numberOfSteps;
    $[23] = t3;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t2 || $[27] !== t8) {
    t9 = <SplitLayout>{t1}<SplitLayout.Content>{t2}{t8}</SplitLayout.Content></SplitLayout>;
    $[26] = t2;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
export default FormScreen;